import type { InvoiceRowData } from "@/components/shared/data-table";
import useMultipleSelect from "@/components/shared/tables/multiSelect";
import { Checkbox } from "@/components/ui/checkbox";
import type { CellContext } from "@tanstack/react-table";
import { useCallback } from "react";

export const SelectCell = ({
  row,
  table,
}: CellContext<InvoiceRowData, unknown>) => {
  const { setCurrentSelectValue, setShiftDown } = useMultipleSelect(table);

  const handleOnChange = useCallback(
    (value: any) => {
      row.toggleSelected(!!value);
    },
    [row, setCurrentSelectValue],
  );

  const handleOnCheckedChange = useCallback(
    (value: any) => {
      row.toggleSelected(!!value);
      setCurrentSelectValue({ row, value });
    },
    [row, setCurrentSelectValue],
  );

  const handleOnClick = useCallback(
    (event: any) => {
      if (event.shiftKey) {
        // should refector this: Problem is that the checkbox does not pass event and value to same handler,
        // so built this custom approach and call two funciotn, one in on click and other in on checked change
        setShiftDown(true);
      }
    },
    [setShiftDown],
  );

  return (
    <div
      onClick={(event) => event.stopPropagation()}
      className="flex items-center justify-center w-full"
    >
      <Checkbox
        checked={row.getIsSelected()}
        onChange={handleOnChange}
        onClick={handleOnClick}
        onCheckedChange={handleOnCheckedChange}
        aria-label="Select row"
      />
    </div>
  );
};
